module.exports = __webpack_public_path__ + "img/es.f5311bf6.svg";